module.exports = __webpack_public_path__ + "./fonts/GothamBook.ttf";